import { useEffect } from "react";
import Lenis from "lenis";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => 1 - Math.pow(1 - t, 4),
      smoothWheel: true,
    });
    // Expose so anchor clicks can use it for smooth in-page scroll.
    window.__lenis = lenis;
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    function onAnchorClick(e) {
      const a = e.target.closest && e.target.closest('a[href^="#"], a[href^="/#"]');
      if (!a) return;
      const raw = a.getAttribute("href");
      // ignore admin/booking or empty
      if (!raw || raw === "#") return;
      const hash = raw.includes("#") ? "#" + raw.split("#")[1] : "";
      if (!hash || hash.length < 2) return;
      const el = document.querySelector(hash);
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -72, duration: 1.2 });
      // update URL without jumping
      history.replaceState(null, "", hash);
    }
    document.addEventListener("click", onAnchorClick);

    return () => {
      document.removeEventListener("click", onAnchorClick);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);
}
